import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-gallery",
  "use": "icon-gallery-usage",
  "viewBox": "0 0 19 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 16\" id=\"icon-gallery\"><ellipse cx=\"9.5\" cy=\"9.2\" rx=\"2.66\" ry=\"2.8\" /><path d=\"M13.818 2.962V0H5.182v2.962H0V16h19V2.962h-5.182zM9.5 13.925c-1.863 0-3.542-1.155-4.255-2.927-.713-1.771-.319-3.81.998-5.167a4.51 4.51 0 0 1 5.02-1.028c1.721.734 2.843 2.463 2.843 4.38-.002 2.618-2.063 4.74-4.606 4.743z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol